import { E_ROUTE_ADMIN } from './route.types';
export const admin = [
    {
        name: E_ROUTE_ADMIN.ADMIN,
        path: '/admin',
        redirect: {
            name: E_ROUTE_ADMIN.ACCOUNTS,
        },
        component: () => import(/* webpackChunkName: "admin" */ '../../views/admin/Admin.vue'),
        props: true,
        children: [
            {
                name: E_ROUTE_ADMIN.ACCOUNTS,
                path: 'accounts',
                component: () => import(/* webpackChunkName: "admin" */ '../../views/admin/Accounts/Accounts.vue'),
                props: true,
                meta: {
                    permission: 'AdminPatsnapAccountList',
                    isAdmin: true,
                },
            },
            {
                name: E_ROUTE_ADMIN.ROLES,
                path: 'roles',
                component: () => import(/* webpackChunkName: "admin" */ '../../views/admin/Roles/Roles.vue'),
                props: true,
                meta: {
                    permission: 'AdminRoleShow',
                    isAdmin: true,
                },
            },
            {
                name: E_ROUTE_ADMIN.HISTORY,
                path: 'history',
                component: () => import(/* webpackChunkName: "admin" */ '../../views/admin/History/History.vue'),
                props: true,
                meta: {
                    permission: 'AdminHistory',
                    isAdmin: true,
                },
            },
            {
                name: E_ROUTE_ADMIN.AUDIT,
                path: 'audit',
                component: () => import(/* webpackChunkName: "admin" */ '../../views/admin/Audit/Audit.vue'),
                props: true,
                meta: {
                    permission: 'AdminAudit',
                    isAdmin: true,
                },
            },
            {
                name: E_ROUTE_ADMIN.CORS_WHITELIST,
                path: 'cors-whitelist',
                component: () => import(/* webpackChunkName: "admin" */ '../../views/admin/CorsWhitelistManagement/CorsWhitelistManagement.vue'),
                props: true,
                meta: {
                    permission: 'AdminCorsWhitelist',
                    isAdmin: true,
                },
            },
            {
                name: E_ROUTE_ADMIN.SSO_REDIRECT_WHITELIST,
                path: 'sso-redirect-whitelist',
                component: () => import(/* webpackChunkName: "admin" */ '../../views/admin/SsoRedirectWhitelistManagement/SsoRedirectWhitelistManagement.vue'),
                props: true,
                meta: {
                    permission: 'AdminCorsWhitelist',
                    isAdmin: true,
                },
            }
        ],
    }
];
